import config from '../../config';
import API from '../api';

const { baseUrl } = config.coreApi;

const getSolutions = async () => {
  await API.refreshTokenWhenNeeded();
  const url = `${baseUrl}/solutions`;
  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() }
  }).then(res => API.generateResponse(res));
};

const getSolutionsConfig = async (sid, page = '', filter = '', orderBy = 'displayName, id') => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/solutions/${sid}/configurations?pageSize=200&pageToken=${page}&filter=${filter}&orderBy=${orderBy}`;
  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() }
  }).then(res => API.generateResponse(res));
}; //TODO: Missing update types (AUdience, Traffic, Custom)

const getSingleSolutionConfig = async (sid, scid) => {
  await API.refreshTokenWhenNeeded();
  const url = `${baseUrl}/solutions/${sid}/configurations/${scid}`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() }
  }).then(res => API.generateResponse(res));
};

const createSolutionConfig = async solutionConfig => {
  await API.refreshTokenWhenNeeded();
  const url = `${baseUrl}/solutions/${solutionConfig.solutionId}/configurations`;
  return fetch(url, {
    method: 'POST',
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    body: JSON.stringify(solutionConfig)
  }).then(res => res.json());
};

const updateSolutionConfig = async (solutionConfig, fields) => {
  await API.refreshTokenWhenNeeded();
  const fieldsToUpdate = fields.map(field => `updateMask=${field}`).join('&');
  const url = `${baseUrl}/solutions/${solutionConfig.solutionId}/configurations/${solutionConfig.id}?${fieldsToUpdate}`;
  return fetch(url, {
    method: 'PATCH',
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    body: JSON.stringify(solutionConfig)
  }).then(res => res.json());
};

const getDevicesFromPreset = async (sid, scid) => {
  await API.refreshTokenWhenNeeded();
  const url = `${baseUrl}/solutions/${sid}/configurations/${scid}:getDeviceIds`;
  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() }
  }).then(res => API.generateResponse(res));
};

export {
  getSolutions,
  getSolutionsConfig,
  getSingleSolutionConfig,
  createSolutionConfig,
  updateSolutionConfig,
  getDevicesFromPreset
};
